// extracted by mini-css-extract-plugin
export default {"list":"tMYI4","list__group":"kSSn0"};